<button [class]="'rw-button ' + class" [disabled]="disabled" [type]="type">
  <ng-content></ng-content>
</button>